export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7038.6fb866c1.jpg";